module.exports = __webpack_public_path__ + "static/media/thumbnail.ecba4886.jpg";